import { useState } from 'react';
import type { ExportJobsFilters } from '../models/ExportJob';

const PAGE_SIZE = 20;

const INITIAL_FILTERS: ExportJobsFilters = {
  status: '',
  exportKind: '',
  createdAtFrom: '',
  createdAtTo: '',
};

export function useExportJobsPage() {
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState<ExportJobsFilters>(INITIAL_FILTERS);

  const applyFilters = (newFilters: ExportJobsFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  const resetFilters = () => {
    setFilters(INITIAL_FILTERS);
    setPage(1);
  };

  return {
    page,
    pageSize: PAGE_SIZE,
    filters,
    setPage,
    applyFilters,
    resetFilters,
  };
}
